"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCatalogItemVariantsSelect = void 0;
const next_i18next_1 = require("next-i18next");
const fdr_lib_misc_catalogs_1 = require("@hotelplan/fdr.lib.misc.catalogs");
function useCatalogItemVariantsSelect(item) {
    var _a;
    const [t, i18n] = (0, next_i18next_1.useTranslation)('catalogs');
    const language = i18n.language;
    const formatRange = ({ from, to }) => {
        return `${(0, fdr_lib_misc_catalogs_1.formatToCatalogsDate)(from, language)} ${t('catalogs:to')} ${(0, fdr_lib_misc_catalogs_1.formatToCatalogsDate)(to, language)}`;
    };
    const options = item.variants
        ? (_a = item.variants) === null || _a === void 0 ? void 0 : _a.map(variant => ({
            label: formatRange(variant),
            value: variant.id,
        }))
        : [];
    return {
        options,
        value: item.id,
    };
}
exports.useCatalogItemVariantsSelect = useCatalogItemVariantsSelect;
//# sourceMappingURL=useCatalogItemVariantsSelect.js.map